module.exports = __webpack_public_path__ + "static/assets/5b9fc46c62a3ae9612195e05c5425bef.svg";